import { render, staticRenderFns } from "./FornecedorContato.vue?vue&type=template&id=56fd74d4"
import script from "./FornecedorContato.vue?vue&type=script&lang=js"
export * from "./FornecedorContato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports